<div class="modal-header">
    <h3 class="modal-title">Select Employee</h3>
</div>
<div class="modal-body">
    <div class="row">
        <div class="card-body">
            <div class="row">
                <div style="margin-left:15px; margin-right:15px;"  role="alert" class="alert alert-info">
                    This action will automatically create an employee group for this individual employee.
                </div>
                <div class="col-lg-6">
                    <strong>Employee:</strong>
                    <search-drop-down [dropDownList]="employees" (click)="isEmployeeGroup()" [(model)]="individualFilter.Employee" [where]="'super'" placeholder="Type to search..."
                            [(searchText)]="formData.employeeLabel" (searchTextChanged)="searchEmployees()" display-key="FullName" modelKey="KeyID">
                    </search-drop-down>
                </div>
                <div class="col-lg-2">
                    <button type="button" class="btn btn-primary buttonNoLabel" (click)="addByIndividual()" [disabled]="individualFilter.Employee == null">
                        Add
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>